<template>
	<div class="head">
		<div el-table v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 1, 39, 0.8)">
			<el-container>
				<el-header height='160px'>
					<div class="upper">
						<el-row>
							<el-col :span="12">
								<div class="time">
									{{ nowTime }} 星期{{ week | getweek }}
								</div>
							</el-col>
							<el-col :span="12">
								<div class="button">
									<el-row>
										<el-col :span="8">
											<!-- <div style="width: 100px;text-align: center;">
												<img src="../assets/home.png" />
											</div> -->
										</el-col>
										<el-col :span="8">
											<!-- <div style="width: 100px;text-align: center;">
												<img src="../assets/screen.png" />
											</div> -->
										</el-col>
										<el-col :span="8">
											<div style="width: 100px;text-align: center;" @click="returns()">
												<img src="../assets/return.png" />
											</div>
										</el-col>
									</el-row>
								</div>
							</el-col>
						</el-row>
					</div>
				</el-header>
				<el-main>
					<el-row>
						<el-col :span="8">
							<div style="width: 94%;height: 870px;">
								<div class="containerone">
									<div class="boxup">
										<el-row>
											<el-col :span="2" class="ioc" />
											<el-col :span="22" class="tieletext">
												人大概况
											</el-col>
										</el-row>
									</div>
									<div style="overflow: hidden;height: 200px;">
										<div class="gktext">
											1954年7月滕县第一届人民代表大会召开，开始行使地方国家权力关的职能。1988年5月，经国务院批准，撤销滕县，建立滕州市，滕县届人民代表大会更名为滕州市第+据修改后的宪法规定，自第-三届人民代表大会开始收为5年1993年2日至今，滕州市人民代表大会历经第+二至九届共7届人民表大会。滕州市人民代表大会在本行政区域内，保证宪法、法律、行政法规的遵守和执行;依照法律规定的权限，通过和发布决议，审查和决定地方的经济建设、文化建设和公共事业建设的计划;审查和批准本行政区域内的国民经济和社会发展计划、预算以及它们的执行情况的报告。1981年5月15日滕县第九届人民代表大会第一次会议首次选举产
											了滕县人民代表大会常务委员会常委会滕县人大常委会)对本级人民后
											行使人民代表大会闭会期间的地方国家权力机关职能代表大会负责并报告工作。1988年5月撤县设市后，滕县人大常委会更名为滕州市人大常委会。滕州市人大常委会自设立到如今的滕州市第十九届人大常委会已历经11届，通过召开常委会会议、执法检查、视察、调研、评议、专题询问及联系代表与选民等活动，依法行使决定权、监督权和任免权，促进了滕州改革开放和经济建设及各项社会事业的健康发展，推动社会主义民主法治进程。
										</div>
									</div>
								</div>
								<div style="width: 100%;height: 590px;">
									<div class="containerb">
										<div class="boxup">
											<el-row>
												<el-col :span="2" class="ioc" />
												<el-col :span="22" class="tieletext">
													人大常委会组织架构
												</el-col>
											</el-row>
										</div>
										<div class="zzjg">
											<div
												style="width: 100%;height:48px;text-align: center;margin-left: 20px;line-height: 48px;font-size: 17px;color: #fff;font-weight: 600;;">
												滕 州 市 人 民 代 表 大 会
											</div>
											<div
												style="width: 100%;height:40px;margin-top: 10px;text-align: center;margin-left: 20px;line-height: 40px;font-size: 17px;color: #fff;font-weight: 600;">
												滕州市人民代表大会常务委员会
											</div>
											<div
												style="width: 100%;height:40px;margin-top: 12px;text-align: center;margin-left: 20px;line-height: 47px;font-size: 17px;color: #fff;font-weight: 600;">
												主 任 会 议
											</div>
											<div style="width: 100%;height:30px;margin-top: 38px;">
												<div style="width: 100%;height: 100%;display: flex;">
													<div
														style="width: 20%;height:30px;margin-left: 22.5%;text-align: center;line-height: 30px;color: #fff;font-size: 17px;">
														专门委员会
													</div>
													<div
														style="width: 33%;height:30px;margin-left: 14%;text-align: center;line-height: 32px;color: #fff;font-size: 17px;">
														工作机构和办事机构
													</div>
												</div>

												<div
													style="width: 100%;height:160px;margin-top: 20px;display: flex;justify-content: center;">
													<div style="width: 34%;height:160px;margin-left: 9%;">

														<div v-for="item in office"
															style="color: #fff;width: 100%;height: 20px;line-height: 20px;padding: 3px 0;">
															<div class="boxlk">
																<el-popover placement="right" trigger="click">
																	<div style="width:100% ;height: 540px;">
																		<div class="boximg">
																			<div
																				style="font-size: 20px;font-weight: 600;padding: 0 0 10px 0;">
																				{{item.tit}}
																			</div>
																			<div v-html="item.name1" />
																		</div>
																	</div>
																	<div style="font-size: 14px;" slot="reference">
																		<img style="width: 12px;height: 12px;"
																			src="../assets/点.png" />
																		{{item.tit}}
																	</div>
																</el-popover>
															</div>
														</div>
													</div>
													<div style="width: 36%;height:270px;">
														<div v-for="item in officeone"
															style="color: #fff;width: 100%;height: 20px;line-height: 20px;padding: 2px 0;">
															<el-popover placement="right" trigger="click">
																<div style="width:100% ;height: 540px;">
																	<div class="boximg">
																		<div
																			style="font-size: 20px;font-weight: 600;padding: 0 0 10px 0;">
																			{{item.tit}}
																		</div>
																		<div v-html="item.name1" />
																	</div>
																</div>
																<div style="font-size: 14px;" slot="reference">
																	<img style="width: 12px;height: 12px;"
																		src="../assets/点.png" />
																	{{item.tit}}
																</div>
															</el-popover>
														</div>
													</div>
												</div>

											</div>
											<div
												style="margin-left:19%;width:33.5%;height:30px;margin-top: 205px;text-align: center;line-height: 30px;color: #fff;font-size: 17px;">
												代表资格审查委员会
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-col>
						<el-col :span="16">
							<div style="width: 95%;height: 870px;margin-left: 5%;">
								<div style="width: 100%;height: 500px;">
									<div class="boxupa">
										<el-row>
											<el-col :span="2" class="ioc" />
											<el-col :span="22" class="tieletext">
												人大概况
											</el-col>
										</el-row>
									</div>
									<div class="rotationtiele">
										<el-row :gutter="20">
											<el-col :span="4">
												<div style="text-align: left;margin-left: 10px;">
													代表团名称
												</div>
											</el-col>
											<el-col :span="4" v-for="item in tit">
												<div style="text-align: center;">
													{{item.tit}}
												</div>
											</el-col>
										</el-row>
									</div>
									<div>
										<dv-scroll-board :config="config" style="width:100%;height:380px" />
									</div>
								</div>
								<div style="width: 100%;height: 370px;">
									<div class="boxupa">
										<el-row>
											<el-col :span="2" class="ioc" />
											<el-col :span="22" class="tieletext">
												代表结构
											</el-col>
										</el-row>
									</div>
									<div
										style="width: 100%;height: 305px;margin-top: 30px;background-color: #021a58;border-radius: 8px;display: flex;">
										<div class="btbj" style="width: 50%;height: 100%;display: flex;">
											<div style="width: 46%;height: 100%;margin-left: 8%;">
												<dv-active-ring-chart :config="btone" style="width:100%;height:100%" />
											</div>
											<div style="width: 36%;height: 74%;margin-top: 7%;">
												<div style="color: #fff;">
													<div v-for="item in lis">
														<div style="display: flex;height: 36px;line-height: 35px;">
															<div :style="item.style" />ᅟ{{item.name}}
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="btbj" style="width: 50%;height: 100%;display: flex;">
											<div style="width: 46%;height: 100%;margin-left: 8%;">
												<dv-active-ring-chart :config="bttwo" style="width:100%;height:100%" />
											</div>
											<div style="width: 36%;height: 74%;margin-top: 7%;text-align: center;">
												<div class="tieletextco"
													style="font-size: 18px;font-weight: 550;line-height: 160px;width: 100%;height: 50%;">
													男女比例
												</div>
												<div style="color:#d9d9d9;font-size: 16px;font-weight: 600;">
													<el-row :gutter="34">
														<el-col :span="12">
															<div style="text-align:right;margin-top: 1px;">
																<img style="width: 14px;height: 14px;"
																	src="../assets/点.png" />
																男
															</div>
														</el-col>
														<el-col :span="12">
															<div
																style="text-align: left;display: flex;line-height: 10px;margin-top: 7px;">
																<div
																	style="width: 10px;height: 10px;background-color: red;border-radius: 40%;" />
																ᅟ女
															</div>
														</el-col>
													</el-row>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-col>
					</el-row>
				</el-main>
			</el-container>
		</div>

	</div>
</template>

<script>
	import moment from 'moment';
	import * as echarts from 'echarts';
	import axios from 'axios';
	import {
		getport
	} from '@/api/api'
	export default {
		data() {
			return {
				nowTime:'',
				week:'',
				gender: [],
				office: {},
				officeone: {},
				loading: false,
				tit: [
					// {tit:'代表团名称'},
					{
						tit: '代表数量'
					},
					{
						tit: '建议办理数量'
					},
					{
						tit: '工作动态数量'
					},
					{
						tit: '履职活动数量'
					},
					{
						tit: '民生实事数量'
					},
				],
				lis: [{
						style: 'width: 15px;height: 15px;background-color:#fd5902;margin-left:24%;margin-top: 10px;',
						name: '企事业单位',
					}, {
						style: 'width: 15px;height: 15px;background-color:#073b74;margin-left:24%;margin-top: 10px;',
						name: '农民',
					}, {
						style: 'width: 15px;height: 15px;background-color:#708efe;margin-left:24%;margin-top: 10px;',
						name: '工人',
					},
					{
						style: 'width: 15px;height: 15px;background-color:#28fcf0;margin-left:24%;margin-top: 10px;',
						name: '党政领导干部',
					},
					{
						style: 'width: 15px;height: 15px;background-color:#046dfd;margin-left:24%;margin-top: 10px;',
						name: '专业技术人员',
					},
					{
						style: 'width: 15px;height: 15px;background-color:#d3d3d5;margin-left:24%;margin-top: 10px;',
						name: '其他',
					}
				],
				config: {
					rowNum: '9',
					data: [
						['洪绪代表团', '83', '6', '32', '10', '12'],
						['东郭代表团', '154', '12', '38', '10', '12'],
						['滨湖代表团', '151', '12', '26', '10', '12'],
						['大坞代表团', '130', '12', '24', '10', '12'],
						['界河代表团', '115', '12', '32', '10', '12'],
						['龙阳代表团', '112', '12', '28', '10', '12'],
						['级索代表团', '109', '12', '34', '10', '12'],
						['姜屯代表团', '129', '12', '24', '10', '12'],
						['荆河代表团', '23', '12', '41', '10', '12'],
						['北辛代表团', '31', '12', '60', '10', '12'],
						['东沙河代表团', '19', '12', '31', '10', '12'],
						// ['龙泉代表团', '5', '12', '8', '10', '12'],
						['善南代表团', '12', '12', '22', '10', '12'],
						['西岗代表团', '149', '12', '36', '10', '12'],
						['官桥代表团', '116', '12', '27', '10', '12'],
						['南沙河代表团', '94', '12', '21', '10', '12'],
						['羊庄代表团', '113', '12', '29', '10', '12'],
						['张汪代表团', '123', '12', '35', '10', '12'],
						['鲍沟代表团', '125', '12', '46', '10', '12'],
						['木石代表团', '95', '12', '34', '10', '12'],
						['柴胡店代表团', '76', '12', '26', '10', '12'],
					],
					columnWidth: [265, 200, 200, 190, 200],
					oddRowBGC: 'transparent',
					evenRowBGC: '#002b58',
				},
				bttwo: {
					color: ['#046dfc', '#fe6c6c'],
					radius: '70%',
					activeRadius: '65%',
					lineWidth: 30,
					data: [{

							name: '男',
							value: 1
						},
						{

							name: '女',
							value: 1
						}
					],
					digitalFlopStyle: {
						fontSize: 20
					},
				},
				btone: {
					color: ['#28fcf0', '#046dfd', '#708efe', '#d3d3d5', '#073b74', '#fd5902'],
					radius: '70%',
					activeRadius: '65%',
					lineWidth: 30,
					data: [{
							name: '其他',
							value: 220
						},
						{
							name: '农民',
							value: 120
						},
						{
							name: '工人',
							value: 120
						},
						{
							name: '企事业单位',
							value: 120
						},
						{
							name: '专业技术人员',
							value: 120
						},
						{
							name: '党政领导干部',
							value: 120
						}
					],
					digitalFlopStyle: {
						fontSize: 20
					},
					// showOriginValue: true,

				},
			}
		},
		created() {
			this.getzzjg()
			this.getnannv()
			this.getjiegou()
			this.getCurrentTime()
		},
		filters: {
			getweek(e) {
				var week = ['一', '二', '三', '四', '五', '六', '日']
				return week[e - 1]
			},
		},
		mounted() {

		},
		methods: {
			getCurrentTime() {
				this.nowTime = moment().format('YYYY年MM月DD日')
				this.week = moment().format('E')
			},
			returns() {
				this.$router.replace({
					path: '/'
				});
			},
			getzzjg() {
				let path = '?id=7'
				getport('', path).then(res => {
					// console.log(res)
					this.office = res.data
					let path = '?id=8'
					getport('', path).then(res => {
						// console.log(res)
						this.officeone = res.data
					})
				})
			},
			getnannv() {
				let path = '?id=9'
				getport('', path).then(res => {
					console.log('男女', res.data)
					this.bttwo.data = res.data
					this.bttwo = {
						...this.bttwo
					}
				})
			},
			getjiegou() {
				let path = '?id=10'
				getport('', path).then(res => {
					console.log('结构', res.data)
					this.btone.data = res.data
					this.btone = {
						...this.btone
					}
				})
			}

		}
	}
</script>

<style scoped>
	body {
		width: 1920px;
		height: 1080px;
		display: flex;
		margin: 0px auto;
		position: relative;
		justify-content: center;
		background-color: #000127;

	}

	.upper {
		width: 1835px;
		padding: 30px 0 0 0;
		position: relative;
		background-size: contain;
		height: 160px !important;
		background: url('../assets/tieliepng.png') no-repeat center;
	}

	.time {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-left: 5%;
		margin-top: 50px;
		line-height: 40px;
		/* border: 1px solid #aa0000; */
	}

	.button {
		width: 40%;
		height: 40px;
		color: #ffffff;
		font-size: 20px;
		margin-top: 70px;
		margin-left: 55%;
		line-height: 40px;
		display: flex;
		justify-content: center;
	}

	.boxup {
		width: 100%;
		height: 30px;
		background: url('../assets/bjt.png') no-repeat;
		background-size: cover;
	}

	.boxupa {
		width: 36%;
		height: 30px;
		background: url('../assets/bjt.png') no-repeat;
		background-size: cover;
	}

	.ioc {
		height: 30px;
		background: url('../assets/ioc.png') no-repeat center;
	}

	.tieletext {
		height: 30px;
		font-size: 19px;
		font-weight: 550;
		line-height: 30px;
		background-image: -webkit-linear-gradient(bottom, #A3D6FF, #F3F7FB, #F3F7FB);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.tieletextco {
		font-size: 18px;
		font-weight: 550;
		background-image: -webkit-linear-gradient(bottom, #00aaff, #ffffff, #ffffff, #ffffff);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.containerone {
		width: 100%;
		height: 280px;
		/* border: 1px solid #ffffff; */
		background: url('../assets/buleimg.png') no-repeat top;
		background-size: 100% 240px;

	}

	.containerb {
		width: 100%;
		height: 590px;
		/* border: 1px solid #ffffff; */
		background: url('../assets/buleimg.png') no-repeat top;
		background-size: 100% 590px;
		border-bottom-left-radius: 6px;
		border-bottom-right-radius: 6px;
	}

	.rotationtiele {
		padding: 20px 0;
		width: 100%;
		height: 30px;
		color: #00EAFF;
		font-size: 18px;
		font-weight: 550;
	}

	.zzjg {
		margin-top: 20px;
		width: 94%;
		height: 500px;
		background: url('../assets/kuangj.png') no-repeat top;
		background-size: 80% 500px;
		/* border: 1px solid #ffffff; */
	}

	.btbj {
		background: url('../assets/btbj.png') no-repeat center;
	}

	.boximg {
		width: 400px;
		height: 100%;
		padding: 20px 20px 0 20px;
		line-height: 30px;
		color: #fff;
		font-size: 16px;
		background: url('../assets/透明框1.png') no-repeat center;
		background-size: 100% 100%;
	}

	.gktext {
		padding: 0 6px 0 14px;
		display: inline-block;
		animation: fadenum;
		animation-duration: var(--text-time);
		animation-iteration-count: infinite; 
		animation-timing-function: linear;
		border-style: none;
		font-size: 18px;
		font-weight: 500;
		/* white-space: nowrap; */
		--text-time: 30s;
		color: #ffffff;
		z-index: 999
	}

	@keyframes fadenum {
		0% {
			transform: translateY(200px);
		}

		100% {
			transform: translateY(-400px);
		}
	}

	/* 1,滚动条 */
	::-webkit-scrollbar {
		width: 5px;
		/* 纵向滚动条 宽度 */
		height: 15px;
		/* 横向滚动条 高度 */
		background: #62C2FF;
		/* 整体背景 */
		border-radius: 10px;
		/* 整体 圆角 */
	}

	/* 4.内层轨道，它会覆盖外层轨道的样式。 */
	::-webkit-scrollbar-track-piece {
		width: 5px;
		background-color: #ffffff;
		margin: 0 -2px 0;
		border-radius: 10px;
	}

	/* 5,滑块 */
	::-webkit-scrollbar-thumb {
		background: #62C2FF;
		min-height: 0px;
		min-width: 50px;
		border-radius: 10px;
	}

	/deep/.dv-scroll-board .rows .row-item {
		font-size: 18px;
		font-weight: 600;
	}
</style>